import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { mainContainerHeaderStyle, headerBarLeftWrapperStyle } from '@/constants/layout'
import { Button } from '@/components/atoms/button'
import { DateRangeField } from '@/components/molecules/date-range-field'
import { AccommodationPaging } from '@/components/molecules/accommodation-paging'
import { SurveyAnswersResponse } from '@/models/survey/answers'

/**
 * 回答一覧ページのヘッダーコンポーネント
 * 日付範囲選択、CSVダウンロード、ページネーション機能を提供
 */
type Props = {
  dateFrom?: string
  dateTo?: string
  onDateRangeChange: (from: string | undefined, to: string | undefined) => void
  onCsvDownload: () => void
  answersData: SurveyAnswersResponse | null
  currentPage: number
  onPageChange: (page: number) => void
}

export const SurveyAnswersHeader: React.FC<Props> = ({
  dateFrom,
  dateTo,
  onDateRangeChange,
  onCsvDownload,
  answersData,
  currentPage,
  onPageChange,
}) => {
  const { t } = useTranslation()

  return (
    <div css={[mainContainerHeaderStyle, { minWidth: '800px' }]}>
      <div css={headerBarLeftWrapperStyle}>
        <DateRangeField
          beginDate={dateFrom}
          endDate={dateTo}
          changeRangeDate={(from, to) => {
            onDateRangeChange(from, to)
            onPageChange(1) // 日付範囲変更時は1ページ目に戻す
          }}
        />
      </div>

      <div css={headerBarLeftWrapperStyle}>
        {answersData && (
          <>
            <Button
              buttonType={4}
              width={160}
              height={32}
              fontSize={12}
              marginRight={12}
              icon={require('@/static/images/download.svg')}
              onClick={onCsvDownload}
            >
              {t('CSV download')}
            </Button>
            <AccommodationPaging page={currentPage} setPage={onPageChange} total={answersData.total} />
          </>
        )}
      </div>
    </div>
  )
}
